module.exports = __webpack_public_path__ + "img/tp9.89f7eb02.png";